import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";

import rootReducer from "./reducers";
import { loadState, saveToLocalStorage } from "./localStorage";

const loggerMiddleware =
  process.env.NODE_ENV === "developlemt" ? createLogger() : undefined;

const middlewares = [loggerMiddleware, ...getDefaultMiddleware()].filter(
  (middleware) => middleware !== undefined
);

export default function configureAppStore() {
  const preloadedState = loadState();

  const store = configureStore({
    reducer: rootReducer,
    middleware: middlewares,
    preloadedState,
  });

  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./reducers", () =>
      store.replaceReducer(import("./reducers"))
    );
  }

  store.subscribe(() => {
    const { auth, userSettings } = store.getState();
    saveToLocalStorage({
      auth: {
        ...auth,
        error: null,
        isLoading: false,
      },
      userSettings: {
        ...userSettings,
        isLoading: false,
      },
    });
  });

  return store;
}
